import { ImageDataTileCodec, ImageDataTileCodecOptions } from "./tiles.codecs.image";
export class Cartesian4TileCodecOptions extends ImageDataTileCodecOptions {
    constructor(p) {
        super(p);
    }
}
export class Cartesian4TileCodec {
    constructor(pixelDecoder, options, canvas) {
        this.pixelDecoder = pixelDecoder;
        this._canvas = canvas;
        this._options = options;
    }
    async decodeAsync(r) {
        const imgData = await (this._canvas ? new ImageDataTileCodec(this._canvas, this._options) : ImageDataTileCodec.Shared).decodeAsync(r);
        if (imgData) {
            const pixels = imgData.data;
            const w = imgData.width;
            const h = imgData.height;
            const size = w * h;
            const pixelSize = pixels.length / size;
            const stride = imgData.width * pixelSize;
            const values = this._buildArray(size);
            let i = 0;
            for (let row = 0; row != imgData.height; row++) {
                const offset = stride * row;
                for (let column = 0; column != imgData.width; column++) {
                    i = this.pixelDecoder.decode(pixels, offset + column * pixelSize, values, i);
                }
            }
            return values;
        }
        return null;
    }
    _buildArray(size) {
        const a = new Array(size);
        if (this._options?.factory) {
            for (let i = 0; i < size; i++) {
                a[i] = this._options.factory();
            }
        }
        return a;
    }
}
//# sourceMappingURL=tiles.codecs.cartesian.js.map